import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { Controller } from 'react-hook-form'

const DecisionForm = ({ isDisbled, formMethods }) => {
  const { control, errors } = formMethods

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Controller
          control={control}
          as={
            <TextField
              label="Observações"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.decisionObservations}
              helperText={errors?.decisionObservations?.message}
              fullWidth
              disabled={isDisbled}
              multiline
              minRows={4}
              maxRows={4}
            />
          }
          name="decisionObservations"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          as={
            <KeyboardDatePicker
              fullWidth
              format="DD/MM/yyyy"
              label="Data prevista"
              helperText={errors?.decisionExpectedDate?.message}
              error={!!errors.decisionExpectedDate}
              inputVariant="outlined"
              onChange={(newValue) => ({ value: newValue })}
              disabled={isDisbled}
            />
          }
          control={control}
          defaultValue={null}
          name="decisionExpectedDate"
          mode="onChange"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          as={
            <KeyboardDatePicker
              fullWidth
              format="DD/MM/yyyy"
              label="Data Finalizado"
              helperText={errors?.decisionFinishedDate?.message}
              error={!!errors.decisionFinishedDate}
              inputVariant="outlined"
              onChange={(newValue) => ({ value: newValue })}
              disabled={isDisbled}
            />
          }
          control={control}
          defaultValue={null}
          name="decisionFinishedDate"
          mode="onChange"
        />
      </Grid>
    </Grid>
  )
}

export default DecisionForm
